<template>
    <page :busy="busy" :tabs="tabs">
        <b-container fluid>
            <b-row>
                <b-col>
                    <grid
                        ref="grid"
                        :column-defs="columnDefs"
                        :row-data="phoneNumbers"
                        :is-auto-height="true"
                    >
                    </grid>
                </b-col>
            </b-row>
        </b-container>
    </page>
</template>

<script>
import { mapGetters } from 'vuex';
import API from '../../api';
import Page from '../generic/page/page.vue';
import Grid from '../generic/grid/grid.vue';
import { formatResponseError } from '../../utils/api';
import {
    SMS_GATEWAY_GET_PHONE_NUMBERS_ENDPOINT,
    SMS_GATEWAY_SET_PHONE_NUMBER_ENDPOINT,
} from '../../endpoints';
import { removeScrollMixin } from '../../mixins/remove-scroll-mixin';


export default {
    name: 'SMSNumbersSetup',
    components: {
        Page,
        Grid
    },
    mixins: [removeScrollMixin],
    data() {
        return {
            busy: false,
            phoneNumbers: [],
        };
    },
    computed: {
        tabs() {
            return [
                {
                    'title': 'SMS Gateway Setup',
                    'route': '/app/sms/gateway/',
                    'active': false
                },
                {
                    'title': 'Phone Numbers',
                    'route': '/app/sms/numbers/',
                    'active': true
                },
                {
                    'title': 'SMS Logs',
                    'route': '/app/sms/logs/',
                    'active': false
                },                       
            ]
        },
        columnDefs() {
            return [
                {
                    field: 'created',
                    headerName: 'Created',
                    type: 'dateTimeColumn',
                    sort: 'desc',
                    minWidth: 190,
                    maxWidth: 190,
                },
                {
                    field: 'number',
                    headerName: 'Number',
                    minWidth: 140,
                },
                {
                    field: 'country.name',
                    headerName: 'From Country',
                    maxWidth: 250,
                    minWidth: 250,
                },
                {
                    field: '',
                    headerName: 'To Country',
                    cellRenderer: ({ data }) => {
                        if (!data.active) {
                            return 'N/A';
                        }
                        else if (data.default) {
                            return 'All Countries';
                        }
                        return data.country.name;
                    },                    
                    maxWidth: 250,
                    minWidth: 250,
                },
                {
                    field: 'default',
                    headerName: 'Default',
                    type: 'switchColumn',
                    sortable: false,
                    maxWidth: 140,
                    minWidth: 140,                    
                    cellRendererParams: ({ data }) => {
                        return {
                            onChange: async ({ node, api }, value) => {
                                node.data.default = value;
                                this.setPhoneNumber(node, api);
                            },
                            disabled: !data?.active || this.phoneNumbers.filter(item => item.active).length <= 1,
                        }
                    },
                },                      
                {
                    field: 'active',
                    headerName: 'Active',
                    type: 'switchColumn',
                    sortable: false,
                    maxWidth: 140,
                    minWidth: 140,                    
                    cellRendererParams: {
                        onChange: async ({ node, api }, value) => {
                            node.data.active = value;
                            this.setPhoneNumber(node, api);
                        },
                    },
                },            
                
            ];
        },        
    },
    async mounted() {
        await this.fetchPhoneNumbers()
    },
    methods: {
        async fetchPhoneNumbers() {
            try {
                this.busy = true;
                const { data } = await API.get(SMS_GATEWAY_GET_PHONE_NUMBERS_ENDPOINT());
                this.phoneNumbers = data;
            } catch(e) {
                this.errorToast({ text: "Could not fetch phone numbers" });
            } finally {
                this.busy = false;
            }
        },
        async setPhoneNumber(node, api) {
            try {
                this.busy = true;
                await API.patch(`${SMS_GATEWAY_SET_PHONE_NUMBER_ENDPOINT(node.data.id)}`, {
                    'default': node.data.default,
                    'active': node.data.active,
                });
                this.fetchPhoneNumbers();
                this.successToast({ text: 'Phone number successfully updated' });
            } catch (e) {
                console.log(e);
                const { generic } = formatResponseError(e);
                this.errorToast({ text: generic || 'Could not update phone number' });
            } finally {
                this.busy = false;
            }            
        }
    },   
};
</script>
